import { UnitOfMeasureTypes } from 'src/common/enumerations/unit-of-measure-type';
import { EJRecordTypes } from '../../common/enumerations/ej-record-types';
import { IElectronicJournalRecord } from '../../common/interfaces/states/IElectronicJournalRecord';

export const getProductCount = (
  ejItems: IElectronicJournalRecord[],
  returnModeActive: boolean,
  includeSaleAndReturnItems: boolean = false,
): number => {
  const hasReturnItem = ejItems.filter(i => i.Type === EJRecordTypes.ReturnItem).length > 0;
  return ejItems
    .filter((item: IElectronicJournalRecord) => {
      if (includeSaleAndReturnItems) {
        return item.Type === EJRecordTypes.Product || item.Type === EJRecordTypes.ReturnItem;
      } else {
        return returnModeActive || hasReturnItem
          ? item.Type === EJRecordTypes.ReturnItem && !item.Voided
          : item.Type === EJRecordTypes.Product && !item.Voided;
      }
    })
    .map(item => {
      return item.UnitOfMeasureCode !== UnitOfMeasureTypes.Each ? 1 : item.Quantity ?? 0;
    })
    .reduce((total, current) => {
      return total + current;
    }, 0);
};
